import { registerStoreItem } from 'utils/storeCreator'
import { consultRankDetail } from 'api/consult'

let store = registerStoreItem({
  store: {
    namespaced: true
  },
  name: 'rank',
  api: consultRankDetail,
  handle: data => data.data,
  defaultValue: {
    title: 0,
    image: 0,
    count: 0,
    list: []
  }
})

export default {
  store,
  name: 'consultrank'
}
